<div class="home_banner stikytop">
    <div class="container propotion">
        <div class="row">
            <div class="col mt-5">
                <h3 class="bannerText1">BUY YOUR DREAM PROPERTY <br> WITH CRYPTOCURRENCY.
                    <!-- <h3 class="bannerText1">BUY PROPERTIES WITH<br> DUCATUS PROPERTY AND <br>GET DUCATUS COINS (DUC) BACK. -->
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <p class="bannerText2">Get up to 10% of the property's<br> purchase price back in DUC.</p>
                <p class="bannerText3">We can also help you find properties that fit your specific needs.<br>
                    Tell us what you are looking for.</p>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <button class="btn  contactUsBtn" [routerLink]="['/contact']">Contact Us</button>
                </div>
            </div>
        </div>
    </div>

    <div class="container propotion" *ngIf="!isSearchClicked">
        <div class="row">
            <!-- <div class="col-lg-3 col-md-2"></div> -->
            <div class="col-lg-7 col-md-12 col-sm-12" style="margin: auto;">
                <div class="input-group mx-auto searchBackground">
                    <input type="text" list="searchLocation" class="form-control searchBar" placeholder="Location"
                        #locationSearch (keyup)="onsearchLocationChange(locationSearch.value,$event)"
                        aria-describedby="basic-addon1">
                    <datalist id="searchLocation">
                        <option *ngFor="let search of locationSearchResults " value="{{search.location}}">
                    </datalist>
                    <!-- <input list="Searchtype" type="text" class="form-control searchBar" placeholder="Property Type"
                        #typeSearch (keyup)="onsearchTypeChange(typeSearch.value)" aria-describedby="basic-addon1">
                    <datalist id="Searchtype">
                        <option *ngFor="let search of typeSearchResult " value="{{search.property_type}}">
                    </datalist> -->
                    <select class="form-select searchBar" aria-label=".form-select-lg" id="type">
                        <option *ngFor="let search of searchType" value="{{search.id}}">{{search.property_type}}
                        </option>
                    </select>
                    <button class="btn searchBtn  searchstyle"
                        (click)="onSearchClick(locationSearchResults == null || locationSearchResults == [] ? 0 :locationSearchResults[0]?.location_id,typeSearchResult == null ? 0: typeSearchResult[0]?.id  )"
                        *ngIf="!isSearchClicked"><i class="fa fa-search"></i> SEARCH</button>
                    <!-- <button class="btn searchBtn" (click)="onClearClick()" *ngIf="isSearchClicked"
                        style="outline: none;box-shadow: none; font-size: large;">Clear</button> -->
                </div>
            </div>
            <!-- , -->
            <!-- <div class="col-lg-2 col-md-2"></div> -->
        </div>

    </div>
    <!-- </div> -->

    <div *ngIf="!isSearchClicked">
        <div class="container propotion listingHeading mt-5 ">
            <div class="propertyListingBg">
                <div class="row p-4">
                    <h4 class="propertysize">Property Listing</h4>
                </div>
                <!-- <div class="container"> -->
                <div class="row">
                    <div class="col-md-12" style="padding-right: 0px; padding-left: 0px;">
                        <div class="item promoted" [attr.data-awards]="actionName1">
                            <div id="custCarousel" class="carousel slide" data-ride="carousel" align="center">
                                <!-- slides -->
                                <div class="carousel-inner d-block w-100">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section1; let i = index'>
                                        <div (click)="getPropId(fav?.id)">
                                            <img src={{serverUrl}}{{fav?.property_image_url}} alt="Hills">
                                        </div>
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyleright" style="text-align: left;">
                                            <h3 class="caroparaheadSingle">{{fav.property_heading| uppercase }}</h3>
                                            <br>
                                            <h5 class="caroparatitleSingle">{{fav.property_subtitle}}</h5>
                                            <br>
                                            <p class="paraelip">{{fav.property_desc_modified}}</p>

                                            <!-- <p class="paraelip" *ngIf="fav?.property_desc">
                                                <span *ngFor="let desc of fav?.property_desc; let i = index">{{desc}}
                                                    <br><br></span>
                                            </p> -->
                                            <div class="row d-flex">
                                                <div class="col">
                                                    <!-- <span class="navigatorDot"
                                                        *ngFor="let fav of section1Thumb; let i = index">
                                                        <a [attr.data-slide-to]=i data-target="#custCarousel">
                                                            <i class="fa fa-circle" aria-hidden="true"></i>
                                                        </a>
                                                    </span> -->
                                                    <span>
                                                        <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 0 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=1 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 1 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=2 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 2 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=3 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 3 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=4 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 4 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=5 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 5 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=6 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 6 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=7 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 7 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=8 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 8 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=9 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 9 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=10 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 10 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=11 data-target="#custCarousel">
                                                            <i class="fa fa-circle navigatorDot {{ i == 11 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <a class="carousel-control-prev" href="#custCarousel" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#custCarousel" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                            <ol class="carousel-indicators list-inline" style="display: inline-flex;">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of section1Thumb; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#custCarousel"> <img
                                            src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg"> </a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </div> -->

            <div class="hidmble" style="height: 50px;"></div>

            <!-- 2 section -->


            <div class="container doubleSection ">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="item promoted" [attr.data-awards]="actionName2">
                            <div id="carousel1" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section2; let i = index' (click)="viewPropDetails(fav.id)">
                                        <img class="d-block w-100" src={{serverUrl}}{{fav.property_image_url}} alt="">
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyle">
                                            <h3 class="caroparahead">{{fav.property_heading| uppercase }}</h3>
                                            <!-- <br> -->
                                            <h5 *ngIf="fav.property_subtitle" class="caroparatitle">
                                                {{fav.property_subtitle}}</h5>
                                            <h5 *ngIf="!fav.property_subtitle" style="visibility : 'hidden'"
                                                class="caroparatitle">not visible</h5>
                                            <div class="container">
                                                <div class="row d-flex">
                                                    <div class="col text-center">
                                                        <span>
                                                            <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                                <i class="fa fa-circle navigatorDot {{ i == 0 ? 'active' : '' }}"
                                                                    aria-hidden="true"></i>
                                                            </a>
                                                            <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                                <i class="fa fa-circle navigatorDot {{ i == 1 ? 'active' : '' }}"
                                                                    aria-hidden="true"></i>
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carousel1" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <!-- <span class="sr-only">Previous</span> -->
                            </a>
                            <a class="carousel-control-next" href="#carousel1" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <!-- <span class="sr-only">Next</span> -->
                            </a>
                            <ol class="carousel-indicators list-inline">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of section2Thumb; let i = index'> <a id="carousel-selector-1 "
                                        class="selected" [attr.data-slide-to]=i data-target="#carousel1"> <img
                                            src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg"> </a>
                                </li>
                            </ol>

                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="item promoted" [attr.data-awards]="actionName3">
                            <div id="carousel2" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section3; let i = index' (click)="viewPropDetails(fav.id)">
                                        <img class="d-block w-100" src={{serverUrl}}{{fav.property_image_url}}
                                            alt="First slide">
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyle">
                                            <h3 class="caroparahead">{{fav.property_heading | uppercase }}</h3>
                                            <!-- <br> -->
                                            <h5 *ngIf="fav.property_subtitle" class="caroparatitle">
                                                {{fav.property_subtitle}}</h5>
                                            <h5 *ngIf="!fav.property_subtitle" style="visibility : 'hidden'"
                                                class="caroparatitle">not visible</h5>
                                            <div class="container">
                                                <div class="row d-flex">
                                                    <div class="col text-center">
                                                        <span>
                                                            <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                                <i class="fa fa-circle navigatorDot {{ i == 0 ? 'active' : '' }}"
                                                                    aria-hidden="true"></i>
                                                            </a>
                                                            <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                                <i class="fa fa-circle navigatorDot {{ i == 1 ? 'active' : '' }}"
                                                                    aria-hidden="true"></i>
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carousel2" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <!-- <span class="sr-only">Previous</span> -->
                            </a>
                            <a class="carousel-control-next" href="#carousel2" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <!-- <span class="sr-only">Next</span> -->
                            </a>
                            <ol class="carousel-indicators list-inline">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of section3Thumb; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#carousel2"> <img
                                            src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg"> </a>
                                </li>
                            </ol>

                        </div>
                    </div>
                </div>
            </div>

            <!-- 2 section end -->
        </div>
        <!-- <div style="height: 10px;"></div> -->
    </div>
    <div *ngIf="!isSearchClicked">
        <div class="container propotion listingHeading1 pt-2 pb-5">
            <!-- </div>
    
        <div class="container listingHeading mt-5"> -->

            <div class=" container">
                <div class="row mb-5">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <!-- <div class="item promoted" data-awards="test"> -->

                        <div class="card">
                            <div class="item promoted" [attr.data-awards]="actionName4"
                                (click)="viewPropDetails(section4?.id)" *ngIf="section4?.property_image_url">
                                <img class="card-img-top d-block w-100"
                                    src={{serverUrl}}{{section4?.property_image_url}}>
                            </div>
                            <div class="card-body ">

                                <div id="module">
                                    <h3 class="elipcont">{{section4?.property_heading | uppercase }}</h3>
                                    <div class="card-text collapse elipara" id="collapseExample1" aria-expanded="false">
                                        <p style="font-weight: 500;">{{section4?.property_subtitle}}</p>
                                        <p>{{section4?.property_desc_modified}}</p>
                                    </div>
                                </div>
                                <a role="button" class="collapsed cardtext1  float-right" data-toggle="collapse"
                                    href="#collapseExample1" aria-expanded="false" aria-controls="collapseExample1"
                                    style="text-decoration: none;font-size: small;">
                                    <span class="if-collapsed">See more </span>
                                    <span class="if-not-collapsed">See less </span>
                                    <i class=" if-collapsed fa fa-angle-down" aria-hidden="true"></i>
                                    <i class=" if-not-collapsed fa fa-angle-up" aria-hidden="true"></i></a>

                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <!-- <div class="item promoted" data-awards="test"> -->
                        <div class="card">
                            <div class="item promoted" [attr.data-awards]="actionName5"
                                (click)="viewPropDetails(section5.id)" *ngIf="section5?.property_image_url">
                                <img class="card-img-top d-block w-100"
                                    src={{serverUrl}}{{section5?.property_image_url}} alt="Card image cap">
                            </div>
                            <div class="card-body">
                                <div id="module">
                                    <h3 class="elipcont">{{section5?.property_heading | uppercase }}</h3>
                                    <div class="card-text collapse elipara" id="collapseExample2" aria-expanded="false">
                                        <p style="font-weight: 500;">{{section5?.property_subtitle}}</p>
                                        <p>{{section5?.property_desc_modified}}</p>
                                    </div>
                                </div>
                                <a role="button" class="collapsed cardtext2  float-right" data-toggle="collapse"
                                    href="#collapseExample2" aria-expanded="false" aria-controls="collapseExample2"
                                    style="text-decoration: none;font-size: small;">
                                    <span class="if-collapsed">See more </span>
                                    <span class="if-not-collapsed">See less </span>
                                    <i class=" if-collapsed fa fa-angle-down" aria-hidden="true"></i>
                                    <i class=" if-not-collapsed fa fa-angle-up" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <!-- <div class="item promoted" data-awards="test"> -->
                        <div class="card">
                            <div class="item promoted" [attr.data-awards]="actionName6"
                                (click)="viewPropDetails(section6.id)" *ngIf="section6?.property_image_url">
                                <img class="card-img-top d-block w-100"
                                    src={{serverUrl}}{{section6?.property_image_url}} alt="Card image cap">
                            </div>
                            <div class="card-body">
                                <div id="module">
                                    <h3 class="elipcont">{{section6?.property_heading | uppercase }}</h3>
                                    <div class="card-text collapse elipara" id="collapseExample3" aria-expanded="false">
                                        <p style="font-weight: 500;">{{section6?.property_subtitle}}</p>
                                        <p>{{section6?.property_desc_modified}}</p>
                                    </div>
                                </div>
                                <a role="button" class="collapsed cardtext3  float-right" data-toggle="collapse"
                                    href="#collapseExample3" aria-expanded="false" aria-controls="collapseExample3"
                                    style="text-decoration: none;font-size: small;">
                                    <span class="if-collapsed">See more </span>
                                    <span class="if-not-collapsed">See less </span>
                                    <i class=" if-collapsed fa fa-angle-down" aria-hidden="true"></i>
                                    <i class=" if-not-collapsed fa fa-angle-up" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </div>
            </div>


            <div class="container" style="padding-right: 0px; padding-left: 0px;">
                <div class="row no-gutters mt-3">
                    <div class="col-md-12" style="padding-right: 0px; padding-left: 0px;">
                        <div class="item promoted" [attr.data-awards]="actionName7">
                            <div id="custCarousel1" class="carousel slide" data-ride="carousel" align="center">
                                <!-- slides -->
                                <div class="carousel-inner d-block w-100">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section7; let i = index'>
                                        <div (click)="viewPropDetails(fav.id)">
                                            <img src={{serverUrl}}{{fav.property_image_url}} alt="Hills" />
                                        </div>
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyleright1" style="text-align: left">
                                            <h3 class="caroparaheadSingle">{{fav.property_heading | uppercase }}</h3>
                                            <br>
                                            <h5 class="caroparatitleSingle">{{fav.property_subtitle}}</h5>
                                            <br>
                                            <p class="paraelip">{{fav.property_desc_modified}}</p>
                                            <!-- <p class="paraelip" *ngIf="fav?.property_desc">
                                                <span *ngFor="let desc of fav?.property_desc; let i = index">{{desc}}
                                                    <br><br></span>
                                            </p> -->
                                            <div class="row d-flex">
                                                <div class="col">
                                                    <!-- <span class="navigatorDot "
                                                        *ngFor="let fav of section7Thumb; let i = index">
                                                        <a [attr.data-slide-to]=i data-target="#custCarousel1">
                                                            <i class="fa fa-circle" aria-hidden="true"></i>
                                                        </a>
                                                    </span> -->
                                                    <span>
                                                        <a [attr.data-slide-to]=0 data-target="#custCarousel1">
                                                            <i class="fa fa-circle navigatorDot {{ i == 0 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=1 data-target="#custCarousel1">
                                                            <i class="fa fa-circle navigatorDot {{ i == 1 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=2 data-target="#custCarousel1">
                                                            <i class="fa fa-circle navigatorDot {{ i == 2 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                        <a [attr.data-slide-to]=3 data-target="#custCarousel1">
                                                            <i class="fa fa-circle navigatorDot {{ i == 3 ? 'active' : '' }}"
                                                                aria-hidden="true"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Left right -->
                            <a class="carousel-control-prev" href="#custCarousel1" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#custCarousel1" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                            <!-- Thumbnails -->
                            <ol class="carousel-indicators list-inline">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of section7Thumb; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#custCarousel1"> <img
                                            src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg">
                                    </a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mblenone" style="height: 50px;"></div>

            <!-- 2 section -->

            <div class="container doubleSection ">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="item promoted" [attr.data-awards]="actionName8">
                            <div id="carousel5" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section8; let i = index' (click)="viewPropDetails(fav.id)">
                                        <img class="d-block w-100" src={{serverUrl}}{{fav.property_image_url}} alt="">
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyle ">
                                            <h3 class="caroparahead">{{fav.property_title | uppercase }}</h3>
                                            <h5 *ngIf="fav.property_subtitle" class="caroparatitle">
                                                {{fav.property_subtitle}}</h5>
                                            <h5 style="visibility : 'hidden'" *ngIf="!fav.property_subtitle"
                                                class="caroparatitle">not visible</h5>
                                        </div>
                                    </div>
                                </div>
                                <!-- <a class="carousel-control-prev" href="#carousel5" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                </a>
                                <a class="carousel-control-next" href="#carousel5" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                </a> -->
                                <ol class="carousel-indicators list-inline">
                                    <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section8Thumb; let i = index'> <a id="carousel-selector-0"
                                            class="selected" [attr.data-slide-to]=i data-target="#carousel5"> <img
                                                src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg">
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="item promoted" [attr.data-awards]="actionName9">
                            <div id="carousel6" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section9; let i = index' (click)="viewPropDetails(fav.id)">
                                        <img class="d-block w-100" src={{serverUrl}}{{fav.property_image_url}}
                                            alt="First slide">
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyle">
                                            <h3 class="caroparahead">{{fav.property_title | uppercase }}</h3>

                                            <h5 *ngIf="fav.property_subtitle" class="caroparatitle">
                                                {{fav.property_subtitle}}</h5>
                                            <h5 style="visibility : 'hidden'" *ngIf="!fav.property_subtitle"
                                                class="caroparatitle">not visible</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#carousel6" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            </a>
                            <a class="carousel-control-next" href="#carousel6" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            </a> -->
                            <ol class="carousel-indicators list-inline">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of section9Thumb; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#carousel6"> <img
                                            src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg">
                                    </a> </li>
                            </ol>

                        </div>
                    </div>
                </div>
            </div>
            <!-- 2 section end -->

            <div class="container doubleSection">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <div class="item promoted" [attr.data-awards]="actionName11">
                            <div id="carousel17" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section11; let i = index' (click)="viewPropDetails(fav.id)">
                                        <img class="d-block w-100" src={{serverUrl}}{{fav.property_image_url}} alt="">
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyle7">
                                            <h3 class="caroparahead">{{fav.property_title | uppercase }}</h3>
                                            <!-- <br> -->
                                            <h5 *ngIf="fav.property_subtitle" class="caroparatitle">
                                                {{fav.property_subtitle}}</h5>
                                            <h5 style="visibility : 'hidden'" *ngIf="!fav.property_subtitle"
                                                class="caroparatitle">not visible</h5>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#carousel17" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carousel17" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a> -->
                            <ol class="carousel-indicators list-inline">
                                <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                    *ngFor='let fav of section11Thumb; let i = index'> <a id="carousel-selector-0"
                                        class="selected" [attr.data-slide-to]=i data-target="#carousel17"> <img
                                            src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg">
                                    </a> </li>
                            </ol>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <div class="item promoted" [attr.data-awards]="actionName10">
                            <div id="carousel7" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section10; let i = index' (click)="viewPropDetails(fav.id)">
                                        <img class="d-block w-100" src={{serverUrl}}{{fav.property_image_url}} alt="">
                                        <div class="carousel-caption requiredTXT" *ngIf="fav.flag == 1">
                                            <h3>REQUIRED</h3>
                                        </div>
                                        <div class="carousel-caption captionstyle7">
                                            <h3 class="caroparahead">{{fav.property_title | uppercase }}</h3>
                                            <!-- <br> -->
                                            <h5 *ngIf="fav.property_subtitle" class="caroparatitle">
                                                {{fav.property_subtitle}}</h5>
                                            <h5 style="visibility : 'hidden'" *ngIf="!fav.property_subtitle"
                                                class="caroparatitle">not visible</h5>
                                            <div class="container">
                                                <div class="row d-flex">
                                                    <div class="col text-center">
                                                        <span>
                                                            <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                                <i class="fa fa-circle navigatorDot {{ i == 0 ? 'active' : '' }}"
                                                                    aria-hidden="true"></i>
                                                            </a>
                                                            <a [attr.data-slide-to]=0 data-target="#custCarousel">
                                                                <i class="fa fa-circle navigatorDot {{ i == 1 ? 'active' : '' }}"
                                                                    aria-hidden="true"></i>
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#carousel7" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <!-- <span class="sr-only">Previous</span> -->
                                </a>
                                <a class="carousel-control-next" href="#carousel7" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <!-- <span class="sr-only">Next</span> -->
                                </a>
                                <ol class="carousel-indicators list-inline">
                                    <li class="list-inline-item {{ i == 0 ? 'active' : '' }}"
                                        *ngFor='let fav of section10Thumb; let i = index'> <a id="carousel-selector-0"
                                            class="selected" [attr.data-slide-to]=i data-target="#carousel7"> <img
                                                src={{serverUrl}}{{fav.thumb_url}} class="img-fluid thumlineimg">
                                        </a> </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>









            <div class=" container listingHeading">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <!-- <div class="item promoted" data-awards="test"> -->

                        <div class="card border-0">
                            <div class="item promoted" [attr.data-awards]="actionName12"
                                (click)="viewPropDetails(section12.id)" *ngIf="section12?.property_image_url">
                                <img class="card-img-top d-block w-100"
                                    src={{serverUrl}}{{section12?.property_image_url}} alt="Card image cap">
                            </div>
                            <div class="card-body">

                                <div id="module">
                                    <h3 class="elipcont">{{section12?.property_title| uppercase }}</h3>
                                    <div class="card-text collapse elipara" id="collapseExample5" aria-expanded="false">
                                        <p style="font-weight: 500; padding-bottom: 3px;">
                                            {{section12?.property_subtitle}}</p>
                                        <p>{{section12?.property_desc}}</p>
                                    </div>
                                </div>
                                <a role="button" class="collapsed cardtext5 float-right" data-toggle="collapse"
                                    href="#collapseExample5" aria-expanded="false" aria-controls="collapseExample5"
                                    style="text-decoration: none;font-size: small;">
                                    <span class="if-collapsed">See more </span>
                                    <span class="if-not-collapsed">See less </span>
                                    <i class=" if-collapsed fa fa-angle-down" aria-hidden="true"></i>
                                    <i class=" if-not-collapsed fa fa-angle-up" aria-hidden="true"></i></a>

                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <!-- <div class="item promoted" data-awards="test"> -->
                        <div class="card border-0">
                            <div class="item promoted" [attr.data-awards]="actionName13"
                                (click)="viewPropDetails(section13.id)" *ngIf="section13?.property_image_url">
                                <img class="card-img-top d-block w-100"
                                    src={{serverUrl}}{{section13?.property_image_url}} alt="Card image cap">
                            </div>
                            <div class="card-body">
                                <div id="module">
                                    <h3 class="elipcont">{{section13?.property_title| uppercase }}</h3>
                                    <div class="card-text collapse elipara" id="collapseExample6" aria-expanded="false">
                                        <p style="font-weight: 500; padding-bottom: 3px;">
                                            {{section13?.property_subtitle}}</p>
                                        <p>{{section13?.property_desc}}</p>
                                    </div>
                                </div>
                                <a role="button" class="collapsed cardtext6 float-right" data-toggle="collapse"
                                    href="#collapseExample6" aria-expanded="false" aria-controls="collapseExample6"
                                    style="text-decoration: none;font-size: small;">
                                    <span class="if-collapsed">See more </span>
                                    <span class="if-not-collapsed">See less </span>
                                    <i class=" if-collapsed fa fa-angle-down" aria-hidden="true"></i>
                                    <i class=" if-not-collapsed fa fa-angle-up" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <!-- <div class="item promoted" data-awards="test"> -->
                        <div class="card border-0">
                            <div class="item promoted" [attr.data-awards]="actionName14"
                                (click)="viewPropDetails(section14.id)" *ngIf="section14?.property_image_url">
                                <img class="card-img-top d-block w-100"
                                    src={{serverUrl}}{{section14?.property_image_url}} alt="Card image cap">
                            </div>
                            <div class="card-body">
                                <div id="module">
                                    <h3 class="elipcont">{{section14?.property_title| uppercase }}</h3>
                                    <div class="card-text collapse elipara" id="collapseExample7" aria-expanded="false">
                                        <p style="font-weight: 500;">{{section14?.property_subtitle}}</p>
                                        <p>{{section14?.property_desc}}</p>
                                    </div>
                                </div>
                                <a role="button" class="collapsed cardtext7 float-right" data-toggle="collapse"
                                    href="#collapseExample7" aria-expanded="false" aria-controls="collapseExample7"
                                    style="text-decoration: none;font-size: small;">
                                    <span class="if-collapsed">See more </span>
                                    <span class="if-not-collapsed">See less </span>
                                    <i class=" if-collapsed fa fa-angle-down" aria-hidden="true"></i>
                                    <i class=" if-not-collapsed fa fa-angle-up" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- search section  -->
    <div *ngIf="isSearchClicked">

        <!-- search property -->

        <div class="container propotion mt-5 mb-5 backgroundGlass" *ngIf="!emptySearchResult">
            <div class="row pt-2" *ngIf="propertySearchResultLocation || propertySearchResultType">
                <div class="col">
                    <h3 *ngIf="propertySearchResultLocation[0]?.location">Location:
                        {{propertySearchResultLocation[0]?.location}} </h3>
                    <h3 *ngIf="propertySearchResultType[0]?.property_type">Type:
                        {{propertySearchResultType[0]?.property_type}}</h3>
                </div>
                <div class="col" style="text-align: right;">
                    <button class="btn searchBtn" (click)="onClearClick()" *ngIf="isSearchClicked"
                        style="outline: none;box-shadow: none; font-size: large;">Clear</button>
                </div>
            </div>
            <div class="row">
                <div class="card-group col-lg-4 col-md-4 col-sm-4 p-2" *ngFor="let item of propertySearchResult">
                    <div class="card ">
                        <img class="card-img-top  d-block w-100" src={{serverUrl}}{{item.property_listing_image_url}}
                            alt="Card image cap" (click)="viewPropDetails(item.id)">
                        <div class="card-body" style="cursor: pointer;">
                            <div id="module">
                                <h5 class="card-title elipcont " data-toggle="tooltip" data-placement="left"
                                    title="{{item.property_title}}" style="color: #414141; font-weight: 600;">
                                    {{item.property_title}}</h5>
                                <p class="card-text elipsubtit" data-toggle="tooltip" data-placement="left"
                                    title="{{item.location}}" style="color: #414141; font-weight: 500;">
                                    {{item.location}}</p>
                                <h5 class="card-text elipcont " style="line-height: 1.5;"
                                    *ngIf="item?.property_price_usd != 0">
                                    <span *ngIf="item?.price_range">{{item?.price_range}}</span>
                                    <b> {{item.property_price}}</b>
                                </h5>
                                <p class="card-text" style="visibility : 'hidden'"
                                    *ngIf="item?.property_price_usd == 0">not
                                    visible</p>
                                <p class="card-text" *ngIf="propData?.property_status">{{item?.property_status}}</p>
                            </div>
                        </div>
                        <div class="card-footer " style="text-align: center;  background-color: white; border: none;">
                            <button type="submit" (click)="viewPropDetails(item.id)"
                                class="btn btn-default float-center pr-5 pl-5 viewPropBtn propbtnsize">View
                                Property</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container propotion backgroundGlass mt-5 pb-5" style="margin: auto" *ngIf="emptySearchResult"
            style="text-align: center;">
            <div class="row" style="text-align: center;">
                <h3 style="color: #891b1d">No result Found</h3>
            </div>
            <div class="container" style="text-align: center;">
                <button class="btn searchBtn" (click)="onClearClick()" *ngIf="isSearchClicked"
                    style="outline: none;box-shadow: none; font-size: large;">Clear</button>
            </div>
        </div>


        <!-- search property end-->
    </div>
    <!-- search section  -->
</div>


<div class="aboutDucatusProp mt-4">
    <div class="container propotion backgroundGlassAbtDuc pt-5 pb-5" id="abtDucProp">
        <div class="row">
            <div class="col-lg-4 col-md-4 mblimgdispnone" style="text-align: center;">
                <img src="assets/About box img merged.png" alt="abt" class="boximgcls" />
            </div>
            <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <p class="abtDUcPropHeading">ABOUT DUCATUS PROPERTY</p>
                            <p class="abtDUcPropContent">At Ducatus, we are advocates of using alternative forms of
                                payment to lead a digital and cashless
                                lifestyle. While the use of digital money in day-to-day life has been gaining
                                considerable
                                momentum over the past few years, buying real estate with digital currency is still
                                something
                                that is mostly unheard of.</p>
                            <!-- <br> -->
                            <p class="abtDUcPropContent">With Ducatus Property, it is now a reality. We are about
                                connecting people with their dream
                                properties, offering premium spaces and homes that are unique while embracing
                                alternative means
                                of financial exchange.</p>
                            <p class="abtDUcPropHeading mt-n5">FINANCE REAL ESTATE PURCHASES WITH CRYPTOCURRENCY</p>
                            <p class="abtDUcPropContent">To view prices in BTC and ETH, simply click the
                                Convert Currency tab in the menu.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- methods of payment section -->
<div class="methodsOfPayment pt-4 pb-4">
    <div class="container propotion">
        <div class="row">
            <div class="col">
                <h3 class="methodofpaymentheading">METHODS OF PAYMENT</h3>
                <p class="methodofpaymentpara">All our listings can be transacted with and paid for using digital
                    currency.
                    Major cryptocurrencies that we accept include Bitcoin, Bitcoin Cash,
                    Litecoin, Ethereum, USDC and more.</p>
            </div>
        </div>
        <div class="row pb-3">
            <div class="col-1"></div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/1.png" alt="btc">
            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/2.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/3.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/4.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/5.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/6.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/7.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/8.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/9.png" alt="btc">

            </div>
            <div class="col-1">
                <img class="changeimgwidth" src="assets/Methods of Payment/10.png" alt="btc">

            </div>
            <div class="col-1"></div>
        </div>
    </div>

</div>


<div class="container propotion pt-5 pb-5" style="background-color: #FFF;">
    <div class="row">
        <div class="col-1"></div>
        <div class="col-10 " style="text-align: center;">
            <img src="assets/Ducatus 1.1.png" class="sizeimgcls" />
        </div>
        <div class="col-2"></div>
    </div>
    <br>
    <br>
    <div class="row">
        <div class="col-1"></div>
        <div class="col-10">
            <p class="techAndComm">TECHNOLOGY, COMMUNITY AND A NEW CRYPTO-ECONOMY</p>
            <p class="techAndCommContent">Ducatus Property is part of the Ducatus Group of companies. We have
                developed
                a group of affiliate
                businesses that encourages the use of digital money in everyday life.</p>
            <p class="techAndCommContent">These Ducatus businesses are the cornerstones of the Ducatus
                Crypto-Economy. From buying an espresso to booking a room at a luxury hotel or buying your dream
                home,
                transactions that used to be cash-only can now be completely cashless.</p>
        </div>
        <div class="col-1"></div>
    </div>
    <div class="row no-gutters">
        <div class="col techAndCommImg">
            <img class="techAndCommImg1" style="width: 100%;" src="assets/techAndComm.png" alt="texhandcomm" />
        </div>
    </div>
</div>


<div class="container propotion ducBusiness pt-5 pb-5">
    <div class="row">
        <div class="row">
            <div class="col">
                <h1 class="mbleimgheader" style="display: inline-flex;">DUCATUS BUSINESSES THAT ACCEPT DUC</h1>
            </div>
        </div>
        <br>
        <br>
        <br>
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-6 .col-xs">
                <a href="https://charity.ducatus.com/" target="_blank">
                    <img src="assets/duc_logos/Charity.png" class="mobileviewimg" />
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 .col-xs">
                <a href="https://travel.ducatus.com/" target="_blank">
                    <img src="assets/duc_logos/Travel.png" class="mobileviewimg" />
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 .col-xs">
                <a href="https://d-pog.com/" target="_blank">
                    <img src="assets/duc_logos/Proof-of-gold.png" class="mobileviewimg" />
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 .col-xs">
                <a href="https://health.ducatus.net/" target="_blank">
                    <img src="assets/duc_logos/Health.png" class="mobileviewimg ml-2" />
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 .col-xs">
                <a href="https://www.merchants.ducatus.com/" target="_blank">
                    <img src="assets/duc_logos/Merchants.png" class="mobileviewimg " />
                </a>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 .col-xs">
                <a href="https://remusnation.com" target="_blank">
                    <img src="assets/duc_logos/Remus.png" class="mobileviewimg" />
                </a>
            </div>
        </div>
    </div>
</div>
<div class="container propotion aboutBackground mt-4 pb-5" id="aboutDucatusGroup" style="margin: auto;">
    <div class="row">
        <div class="col-1"></div>
        <div class="col-10">
            <div class="row parabackimg"></div>
            <div class="row mb-5">
                <div class="col-4" style="background-color: #891B1D; height: 15px; "></div>
            </div>
            <div class="row">
                <h1 class="abtDucatusHeading">ABOUT THE DUCATUS GROUP</h1>
                <br>
                <p class="abtDucatus">Established in December 2016, Ducatus is a Fintech conglomerate that champions the
                    new digital economy. Our offices in Dubai and Europe are responsible for affiliate business such as
                    franchise, merchant partnerships, health and property, as well as charity projects. We have a
                    globally distributed management team that provides management and professional support for the whole
                    group.</p>
                <br>
                <br>
                <p class="abtDucatus"><b>Open up to Boundless Possibilities with Ducatus!</b></p>
            </div>
        </div>
        <div class="col-1"></div>
    </div>
</div>